import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('toggleColorMenuIsShown')(function toggleColorMenuIsShown(isShown, state) {
    var optionState = state.optionState;
    optionState.isColorMenuShown = isShown;
}));
//# sourceMappingURL=toggleColorMenuIsShown.js.map